import cx from "classnames";

import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { EditPencil } from "components/icons/EditPencil";
import { MenuDotsVertical } from "components/icons/MenuDotsVertical";
import { Passkey } from "components/icons/Passkey";
import { TrashSimple } from "components/icons/TrashSimple";
import { formatDate } from "utils/formatDate";
import { WebAuthnCredentialSummary } from "store/apis/webauthn";

type PasskeyListItemProps = {
  credential: WebAuthnCredentialSummary;
  onRemove: (credential: WebAuthnCredentialSummary) => void;
  onRename: (credential: WebAuthnCredentialSummary) => void;
  showTopBorder: boolean;
};

export const PasskeyListItem = ({
  credential,
  onRemove,
  onRename,
  showTopBorder,
}: PasskeyListItemProps) => {
  const lastUsedLabel = credential.last_used_at
    ? `Last used ${formatDate(credential.last_used_at)}`
    : `Added ${formatDate(credential.created_at)}`;

  const handleRemoveClick = () => {
    onRemove(credential);
  };

  const handleRenameClick = () => {
    onRename(credential);
  };

  return (
    <div
      className={cx(
        "t-flex t-items-center t-justify-between t-gap-4 t-py-4",
        showTopBorder &&
          "t-border-0 t-border-t t-border-solid t-border-neutral-10"
      )}
    >
      <div className="t-flex t-items-center t-gap-3">
        <div className="t-flex t-items-center t-justify-center t-size-8 t-rounded-full t-bg-neutral-10 t-text-text-60">
          <Passkey width={16} height={16} />
        </div>
        <div className="t-flex t-flex-col">
          <div className="t-text-body-sm t-text-text-100">
            {credential.device_name || "Passkey"}
          </div>
          <div className="t-text-body-sm-lite t-text-neutral-50">
            {lastUsedLabel}
          </div>
        </div>
      </div>
      <Dropdown.Root>
        <Dropdown.Trigger asChild>
          <div>
            <Button
              type="button"
              customType="ghost_icon"
              size="small"
              aria-label="Passkey options"
            >
              <span className="t-flex t-text-neutral-40">
                <MenuDotsVertical />
              </span>
            </Button>
          </div>
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content align="end" sideOffset={4}>
            <Dropdown.Item textValue="Rename" onSelect={handleRenameClick}>
              Rename
            </Dropdown.Item>
            <Dropdown.Item
              textValue="Remove"
              onSelect={handleRemoveClick}
              type="danger"
            >
              Remove
            </Dropdown.Item>
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
    </div>
  );
};
